<template>
  <a-select
    v-model:value="value"
    show-search
    style="width: 100%"
    :allowClear="true"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="null"
    :options="suggestionData"
    @search="search"
    @change="onChange"
    :disabled="disabled"
  ></a-select>
</template>
<script lang='ts' setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = defineProps({
  modelValue: {
    type: String,
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'changeValues'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(() => {
  search('')
})
watch(props, (newVal) => {
  console.log('watch', newVal.modelValue);
  
  if (newVal.modelValue) {
    let name = newVal.name ? newVal.name.split(']')[1] : ''
    if (!suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/bloggers/suggestion`, {
        // blogger_id: newVal.modelValue,
        blogger_name: name,
        is_strict: props.isStrict,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.suggestion) {
          let value = v.director_name?`${v.username} (${v.director_name})`:v.username
          suggestionData.value.push({
            label: value,
            value: v.id
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      try {
        request.get(`/api/bloggers/suggestion`, {
          blogger_name: name,
          is_strict: props.isStrict,
        }).then((rsp:any) => {
          suggestionData.value = []
          for (let v of rsp.data.suggestion) {
            let value = v.director_name?`${v.username} (${v.director_name})`:v.username
            suggestionData.value.push({
              label: value,
              value: v.id
            })
          }
        })
      } catch(err){
        console.log('err')
      }
    }, 600)
  
}

const onChange = (item, options) => {
  console.log('onChange',item, options);
  if (options) {
    emits('changeValues', {blogger_name: options.label})
    emits('update:modelValue', options.value)
  }
}
</script>
<style lang='scss' scoped>

</style>